import {Component, Module} from 'app/decorators';
import _ from 'lodash';
import BasePicker from 'app/directives/base.picker';

import tpl from './sales.picker.html';


@Module({
    name: "app.directives.sales.picker",
    modules: []
})
@Component({
    selector: 'blnd-salespeople',
    bindings: {
        ngModel: '=',
        mode: '@?',
        multiple: '=?',
    },
    template: tpl,
})
export default class C extends BasePicker {
    constructor (UserStore, $element) {
        "ngInject";
        super($element);
        this.mode = this.mode || 'view';
        if (_.isUndefined(this.multiple)) {
            this.multiple = true;
        }
        this.store = UserStore;
        this.store.init();
        this.items = [];
    }

    refresh (search) {
        let self = this;

        if (!this.enabled) { return; }
        this.store.params.search = search;
        this.store.refresh().then(function (obj) {
            self.items = _.map(obj.list, (o) => {
                return {
                    id: o.id,
                    title: o.title,
                };
            });
         });
    }

    $onDestroy () {
        delete this.items;
        super.$onDestroy();
    }
}



// WEBPACK FOOTER //
// ./src/app/directives/sales.picker.js